import "../default/index" //INHERIT FROM DEFAULT